<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-orange" sprite="group" />
          Call Groups
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-orange" sprite="group" />
            Call Groups
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>

      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
          <el-button class="ml-10 hidden-xs-only" @click="doExport">
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-button @click="openCreateModal">Add New</el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <create-form
      :createVisible="createVisible"
      :clearFormFields="clearFormFields"
      :createProcessing="createProcessing"
      @formsCleared="numInUse = null"
      :numInUse="numInUse"
      :draggableDestTypes="draggableDestTypes"
      :branchOptions="branchOptions"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
      @numberChange="numberChange"
    />

    <edit-form
      :editVisible="editVisible"
      :editProcessing="editProcessing"
      :clearFormFields="clearFormFields"
      :selectedCallGroup="selectedCallGroup"
      @formsCleared="numInUse = null"
      :numInUse="numInUse"
      :numberOptions="numberOptions"
      :draggableDestTypes="draggableDestTypes"
      :branchOptions="branchOptions"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
      @numberChange="numberChange"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import feathersClient from "../../../feathers/feathers-client";
import CreateForm from "./components/createForm";
import EditForm from "./components/editForm";
import { debounce } from "lodash";
import { globalEventBus } from "../../../globalEventBus";
import { ExportToCsv } from "export-to-csv";
import { phoneNumberFormatter } from "@/globals/globals";

export default {
  name: "HuntListTable",
  data() {
    return {
      draggableDestTypes: [
        "SPECIAL",
        "CUSTOM",
        "IVR",
        "VOICEMAIL",
        "PLAYBACK",
        "HUNTLIST",
        "EXT",
        "QUEUE",
        "SMS",
        "MUSICONHOLD",
        "CONDITION"
      ],
      callgroupChannel: null,
      createProcessing: false,
      editProcessing: false,
      deleteProcessing: false,
      tableLoading: false,
      tableData: [],
      allCallGroups: [],
      search: "",
      visibleActionsId: "",
      editVisible: false,
      queryForAvailableNums: "",
      createVisible: false,
      clearFormFields: false,
      callGroupNumber: null,
      numberOptions: [],
      numInUse: null,
      selectedCallGroup: null,
      total: 0,
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-orange" sprite="group" />
                </div>,
              ];
            },
          },
        },
        {
          field: "name",
          title: "Name",
          sortable: true,
          minWidth: 150,
        },
        {
          field: "number",
          title: "Number",
          sortable: true,
          minWidth: 100,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.number)}</span>];
            },
          },
        },
        {
          field: "type",
          title: "Ring Strategy",
          sortable: true,
          minWidth: 150,
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={"delete-" + row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>,
              ];
            },
          },
        },
      ],
      branchOptions: [],
    };
  },
  components: {
    CreateForm,
    EditForm,
  },
  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },
  watch: {
    selectedTenant() {
      this.findCallGroups();
      this.queryBranches();
      feathersClient
        .service("channel-memberships")
        .remove(null, { query: { channelName: this.callgroupChannel } });
      this.joinSocketChannel();
    },
    user() {
      this.findCallGroups();
      if (!this.callgroupChannel) {
        this.joinSocketChannel();
      }
    },
    callGroupNumber: debounce(function () {
      const checkNumberService = feathersClient.service("check-number");
      checkNumberService
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            number: this.callGroupNumber,
          },
        })
        .then((res) => {
          this.numInUse = res;
        });
    }, 500),
    search: debounce(function () {
      this.searchCallGroups();
    }, 500),
  },
  methods: {
    ...mapActions("huntlists", {
      deleteHuntLists: "remove",
      createHuntLists: "create",
      patchHuntLists: "patch",
    }),

    doExport() {
      const data = [...this.tableData];
      if (data.length) {
        const writeData = data.map((item) => ({
          name: item.name,
          number: item.number ? item.number : "",
          type: item.type,
        }));

        const options = {
          filename: "call_groups",
          showLabels: true,
          headers: ["Name", "Number", "Ring Strategy"],
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    searchCallGroups() {
      if (this.search.length) {
        this.tableData = this.tableData.filter(
          (data) =>
            (!!data.number &&
              data.number.toLowerCase().includes(this.search.toLowerCase())) ||
            data.name.toLowerCase().includes(this.search.toLowerCase()) ||
            data.type.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        this.tableData = [...this.allCallGroups];
      }
      this.total = this.tableData.length;
    },

    //General Form and Table Operations
    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    openCreateModal() {
      this.createVisible = true;
      this.clearFormFields = false;
    },

    openEditModal(id) {
      this.editVisible = true;
      this.clearFormFields = false;
      feathersClient
        .service("huntlists")
        .get(id)
        .then((res) => {
          this.selectedCallGroup = res;
          if (
            this.selectedCallGroup.phoneNums &&
            this.selectedCallGroup.phoneNums.length
          ) {
            this.numberOptions = [];
            this.selectedCallGroup.phoneNums.forEach((num) => {
              this.numberOptions.push({
                key: num.id,
                label: num.number,
                disabled: false,
              });
            });
          }
          this.editVisible = true;
        });
    },

    numberChange(number) {
      this.callGroupNumber = number;
    },

    createOperation(params) {
      const createBody = { ...params };
      createBody.checkinuse = createBody.checkinuse ? "on" : "";
      createBody.usemoh = createBody.usemoh ? "on" : "";
      if (createBody.destinations.length) {
        createBody.destinations = createBody.destinations.map(
          ({ id, type, order }) => ({ id, type, order })
        );
      }

      createBody.number = createBody.number ? createBody.number : null;

      this.$confirm("Process call group create?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.createProcessing = true;
          this.createHuntLists(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success",
              });
              this.createProcessing = false;
              this.clearFormFields = true;
              this.cancelOperation("create");
            })
            .catch((error) => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }

              this.createProcessing = false;
            });
        })
        .catch(() => true);
    },

    editOperation(editData) {
      const editBody = { ...editData, tenantId: this.selectedTenant.id };
      editBody.checkinuse = editBody.checkinuse ? "on" : "";
      editBody.usemoh = editBody.usemoh ? "on" : "";

      if (editBody.destinations.length) {
        editBody.destinations = editBody.destinations.map(
          ({ id, type, order }) => ({ id, type, order })
        );
      }

      editBody.number = editBody.number ? editBody.number : null;

      this.$confirm("Process call group edit?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.editProcessing = true;

          this.patchHuntLists([this.selectedCallGroup.id, editBody])
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited Successfully!",
                type: "success",
              });
              this.editProcessing = false;

              this.clearFormFields = true;
              this.cancelOperation("edit");
            })
            .catch((error) => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }

              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation(type) {
      this.clearFormFields = true;
      if (type === "create") {
        this.createVisible = false;
      } else if (type === "edit") {
        this.editVisible = false;
      }
    },

    deleteOperation(id) {
      this.$confirm("Process call group delete?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.deleteProcessing = true;

          this.deleteHuntLists(id)
            .then(() => {
              this.deleteProcessing = false;
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success",
              });
            })
            .catch((error) => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }

              this.deleteProcessing = false;
            });
        })
        .catch(() => true);
    },

    numberFormatter(val) {
      return phoneNumberFormatter(val);
    },

    findCallGroups() {
      this.tableLoading = true;
      this.tableData = [];
      feathersClient
        .service("huntlists")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: {
              name: 1,
            },
          },
        })
        .then((res) => {
          this.tableData = [...res];
          this.allCallGroups = [...res];
          this.total = res.length;
          this.tableLoading = false;
        });
    },

    joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");
      const data = {
        roomType: "admins",
        tenantId: this.selectedTenant.id,
      };
      channelService.create(data).then((res) => {
        this.callgroupChannel = `${data.roomType}/${data.tenantId}`;
      });
    },

    removeListeners() {
      feathersClient.service("huntlists").removeListener("patched");
      feathersClient.service("huntlists").removeListener("created");
      feathersClient.service("huntlists").removeListener("removed");
      globalEventBus.$off("appReconnected");
    },

    queryBranches() {
      feathersClient
        .service("branches")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: {
              name: 1,
            },
          },
        })
        .then((res) => {
          this.branchOptions = [...res];
        }).catch( () => {
          this.branchOptions = [];
      });
    },
  },
  created() {
    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    //record was edited
    //always refresh did destination options
    feathersClient.service("huntlists").on("patched", (data) => {
      const updateIndex = this.tableData.findIndex(
        (item) => item.id === data.id
      );
      const updateAllIndex = this.allCallGroups.findIndex(
        (item) => item.id === data.id
      );
      if (updateIndex >= 0) {
        this.tableData.splice(updateIndex, 1, data);
      }
      if (updateAllIndex >= 0) {
        this.allCallGroups.splice(updateAllIndex, 1, data);
      }
    });

    //record was created
    feathersClient.service("huntlists").on("created", (data) => {
      this.tableData.push(data);
      this.allCallGroups.push(data);
    });

    //record was deleted
    feathersClient.service("huntlists").on("removed", (data) => {
      const indexToRemove = this.tableData.findIndex(
        (item) => item.id === data.id
      );
      const indexAllToRemove = this.allCallGroups.findIndex(
        (item) => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allCallGroups.splice(indexAllToRemove, 1);
      }
    });
  },
  mounted() {
    if (this.user) {
      this.joinSocketChannel();
      this.findCallGroups();
      this.queryBranches();
    }
  },
  beforeDestroy() {
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.callgroupChannel } });
    this.removeListeners();
  },
};
</script>
